import React from 'react';
import { motion } from 'framer-motion';

const FeatureSection: React.FC = () => {
  const features = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      title: "Gagnez des points à chaque achat",
      description: "Accumulez automatiquement des points chez tous nos commerçants partenaires du centre-ville."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Échangez contre des offres exclusives",
      description: "Utilisez vos points pour obtenir des réductions, des cadeaux ou des expériences uniques."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Recevez des notifications personnalisées",
      description: "Soyez alerté des offres spéciales de vos commerces préférés et des promotions à durée limitée."
    }
  ];
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8 shadow-xl border border-white/20"
    >
      <h3 className="text-2xl font-bold mb-6">Comment ça fonctionne</h3>
      
      <motion.div className="space-y-6">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="flex gap-4 items-start"
          >
            <motion.div 
              whileHover={{ 
                rotate: [0, -10, 10, -10, 0],
                scale: 1.05,
                backgroundColor: '#7B1FA2'
              }}
              transition={{ duration: 0.5 }}
              className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center text-white"
            >
              {feature.icon}
            </motion.div>
            
            <div>
              <h4 className="text-lg font-semibold mb-1">{feature.title}</h4>
              <p className="text-white/80">{feature.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
      
      <motion.div 
        className="mt-8 bg-gradient-to-r from-[#7B1FA2]/20 to-[#40E0D0]/20 rounded-xl p-5 border border-white/10"
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 bg-[#7B1FA2] rounded-lg flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <h4 className="text-lg font-semibold">Déjà +45 commerces partenaires !</h4>
        </div>
        <p className="text-white/80">
          Boulangeries, restaurants, boutiques de vêtements, librairies et bien plus encore. Découvrez tous nos commerces partenaires.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default FeatureSection;
